// extracted by mini-css-extract-plugin
module.exports = {"showProducts":"filterproducts_showProducts__1hZoY","submenu":"filterproducts_submenu__1bFqs","Categories":"filterproducts_Categories__3Oii-"};